import React from 'react';
import { useParams } from 'react-router-dom';
import NavBar from '../NavBar.jsx';
import ImageFlipBook from '../ImageFlipBook.jsx';

function NewsletterViewer() {
  const { id } = useParams();

  const newsletters = [
    {
      title: "Newsletter 2023/2024",
      images: [
        "/newsletter/23_24/1_newsletter.png",
        "/newsletter/23_24/2_newsletter.png",
        "/newsletter/23_24/3_newsletter.png",
        "/newsletter/23_24/4_newsletter.png",
        "/newsletter/23_24/5_newsletter.png",
        "/newsletter/23_24/6_newsletter.png",
        "/newsletter/23_24/7_newsletter.png",
        "/newsletter/23_24/8_newsletter.png",
        "/newsletter/23_24/9_newsletter.png",
        "/newsletter/23_24/10_newsletter.png",
        "/newsletter/23_24/11_newsletter.png",
        "/newsletter/23_24/12_newsletter.png"
      ]
    },
    {
      title: "Fall-Winter 2024/2025",
      images: [
        "/newsletter/24_25/2.png",
        "/newsletter/24_25/3.png",
        "/newsletter/24_25/4.png",
        "/newsletter/24_25/5.png",
        "/newsletter/24_25/6.png",
        "/newsletter/24_25/7.png",
        "/newsletter/24_25/8.png",
        "/newsletter/24_25/9.png",
        "/newsletter/24_25/10.png",
        "/newsletter/24_25/11.png",
        "/newsletter/24_25/12.png"
      ]
    },
    {
      title: "Spring-Summer 2024/2025",
      images: [
        "/newsletter/25_26/2.png",
        "/newsletter/25_26/3.png",
        "/newsletter/25_26/4.png",
        "/newsletter/25_26/5.png",
        "/newsletter/25_26/6.png",
        "/newsletter/25_26/7.png",
        "/newsletter/25_26/8.png",
        "/newsletter/25_26/9.png",
        "/newsletter/25_26/10.png",
        "/newsletter/25_26/11.png",
        "/newsletter/25_26/12.png",
        "/newsletter/25_26/13.png",
        "/newsletter/25_26/14.png",
        "/newsletter/25_26/15.png",
        "/newsletter/25_26/16.png",
        "/newsletter/25_26/17.png",
        "/newsletter/25_26/18.png",
        "/newsletter/25_26/19.png",
        "/newsletter/25_26/20.png"
      ]
    }
  ];

  const newsletter = newsletters[id - 1];

  return (
    <>
      <NavBar activeSection="" />
      <div className="min-h-screen bg-mainBlue flex flex-col items-center pt-48 pb-10">
        <h1 className="md:text-4xl text-2xl font-bold text-white mt-5">{newsletter.title}</h1>
        <ImageFlipBook images={newsletter.images} />
      </div>
    </>
  );
}

export default NewsletterViewer;
